import { Flex, ProductColor, Typography } from '@aloft/toolkit-sui';

type DetailLineProps = {
  text?: string;
  noPadding?: boolean;
  color?: ProductColor;
};

export const DetailLine = ({ text = '', noPadding = false, color }: DetailLineProps) => {
  const textWrapSx = { textOverflow: 'ellipsis', textWrap: 'nowrap', overflow: 'hidden' };

  return (
    <Flex paddingRight={noPadding ? '0' : '5rem'}>
      <Typography color={color} __dangerDoNotUseSx={textWrapSx}>
        {text}
      </Typography>
    </Flex>
  );
};
